import React from 'react';
import { BetResponseCode, isMobile, notificationStore } from '@pascal/pascal-core';
import { AdditionalInputValueChangingButtons } from '@pascal/pascal-core/shared/core/enums/additionalInputValueChangingButtons';
import { autoCashOutDataKeys, numPadSectionName } from '../../../../enums';
import { doBetStore } from '../../../../store';
import { divide, toFixed } from '../../../../helpers/arithmeticOperations';

const BetInput = ({
  limits,
  onBlur,
  onChange,
  betAmount,
  isAutoCashOut,
  autoCashOutOdd,
  activeFreeBet,
  showNotification,
  handleOpenNumPad,
  isDisabledBetSection,
  handleChangeInputValue,
  setIsValidatedAmountForManual,
}) => {
  const changeAutoCashOutOdd = (betAmount) => {
    if (isAutoCashOut && autoCashOutOdd && autoCashOutOdd > divide(limits.maxWin, betAmount)) {
      doBetStore.updateAutoCashOutData(
        autoCashOutDataKeys.autoCashOutOdd,
        toFixed(divide(limits.maxWin, betAmount))
      );
      notificationStore.setNotificationType({
        responseCode: BetResponseCode.InValidMaxAutoCashOutOdd,
      });
    }
  };
  return (
    <div
      className={`bet-section-left ${activeFreeBet?.id ? 'passive' : ''} ${isDisabledBetSection}`}
    >
      <button
        type='button'
        className='bet-section-action'
        onClick={() => {
          handleChangeInputValue(AdditionalInputValueChangingButtons.divide);
        }}
      >
        <span>1/2</span>
      </button>
      {/* <div */}
      {/*  className='odd-g-inp-square btn-line-block' // +betAmount <= +limits.minBet ? 'passive' : '' */}
      {/*  onClick={() => { */}
      {/*    handleChangeInputValue(AdditionalInputValueChangingButtons.divide); */}
      {/*    // decidedCallBackCall( */}
      {/*    //   () => changeBetAmount(additionalBetAmountChangingButtons.divide), */}
      {/*    //   true */}
      {/*    // ); */}
      {/*  }} */}
      {/*  title={'1/2'} */}
      {/* > */}
      {/*  <div className='odd-g-inp-square-block'> */}
      {/*    <span>1/2</span> */}
      {/*  </div> */}
      {/* </div> */}
      <div className='bet-section-calc'>
        <div className='bet-section-calc-inner'>
          <button
            type='button'
            className='bet-section-counter'
            onClick={() => {
              handleChangeInputValue(AdditionalInputValueChangingButtons.minus);
            }}
          >
            <i className='ui-lib-minus' />
          </button>
          <input
            type='text'
            maxLength={9}
            readOnly={isMobile()}
            inputMode={isMobile() ? 'none' : 'text'}
            autoComplete='off'
            title={`${betAmount || ''}`}
            className='bet-section-input'
            value={betAmount || ''}
            onBlur={() => {
              const { validatedBetAmount, errorMessageCode } = onBlur(betAmount);
              if (errorMessageCode) {
                showNotification({ responseCode: errorMessageCode });
                setIsValidatedAmountForManual(true);
              }
              onChange(validatedBetAmount);
              changeAutoCashOutOdd(validatedBetAmount);
            }}
            onChange={(e) => {
              if (
                /^([0]{1}|([1-9]{1}\d*))(?:\.\d{0,2})?$/.test(e.target.value) ||
                e.target.value === ''
              ) {
                onChange(e.target.value.replace(',', '.'));
              }
            }}
            {...(isMobile()
              ? { onClick: (e) => handleOpenNumPad(e, numPadSectionName.manual) }
              : {})}
          />
          <button
            type='button'
            className='bet-section-counter'
            onClick={() => {
              handleChangeInputValue(AdditionalInputValueChangingButtons.plus);
            }}
          >
            <i className='ui-lib-plus' />
          </button>
        </div>
      </div>
      <button
        type='button'
        className='bet-section-action'
        onClick={() => {
          handleChangeInputValue(AdditionalInputValueChangingButtons.multiply);
        }}
      >
        <span>x2</span>
      </button>
    </div>
  );
};

export default BetInput;
